// extracted by mini-css-extract-plugin
export default {"header__cart-empty-container":"header__cart-empty-container_oZQ2Wp2_","header__cart-empty-text":"header__cart-empty-text_XSej5WHk"};